import { render } from "./ApprovalFormPageList.vue?vue&type=template&id=34f5b596&scoped=true"
import script from "./ApprovalFormPageList.vue?vue&type=script&lang=ts"
export * from "./ApprovalFormPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-34f5b596"

export default script